// src/pages/admin/add-admin.tsx

import React from 'react';
import { useForm } from 'react-hook-form';
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Swal from 'sweetalert2';

import UserNav from '../../components/navbar/user-nav';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';

const schema = yup.object().shape({
  nombre: yup.string().required('Nombre requerido'),
  correo: yup.string().email('Correo inválido').required('Correo requerido'),
  admin_id: yup
    .string()
    .length(28, 'UID debe tener 28 caracteres')
    .required('UID requerido (cópialo desde Firebase Auth)'),
});

type FormData = yup.InferType<typeof schema>;

export default function AddAdmin() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: FormData) => {
    try {
      const q = query(
        collection(db, 'admin'),
        where('admin_id', '==', data.admin_id)
      );
      const snap = await getDocs(q);

      if (!snap.empty) {
        Swal.fire({
          icon: 'error',
          title: 'Ya existe un admin con ese UID',
        });
        return;
      }

      await addDoc(collection(db, 'admin'), {
        ...data,
        tipo: ['admin'],
      });

      Swal.fire({
        icon: 'success',
        title: 'Administrador registrado',
        text: 'El usuario fue guardado en la colección admin',
      });

      reset();
    } catch (error) {
      console.error('Error al guardar:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo guardar el administrador',
      });
    }
  };

  return (
    <>
      <UserNav />
      <div className="page-title">
        <div className="container">
          <h2 className="ipt-title">Registrar Administrador</h2>
          <span className="ipn-subtitle">Agrega usuarios con acceso total al panel</span>
        </div>
      </div>

      <section className="bg-light">
        <div className="container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="submit-page">
              <div className="form-submit">
                <h3>Datos del Administrador</h3>
                <div className="submit-section row">
                  <div className="form-group col-md-6">
                    <label>Nombre</label>
                    <input
                      {...register('nombre')}
                      className="form-control"
                      placeholder="Ej. Aure Admin"
                    />
                    <small className="text-danger">{errors.nombre?.message}</small>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Correo</label>
                    <input
                      {...register('correo')}
                      className="form-control"
                      placeholder="Ej. admin@admin.com"
                    />
                    <small className="text-danger">{errors.correo?.message}</small>
                  </div>

                  <div className="form-group col-md-12">
                    <label>UID Firebase (admin_id)</label>
                    <input
                      {...register('admin_id')}
                      className="form-control"
                      placeholder="Ej. CódigodeFirebaseUID"
                    />
                    <small className="text-danger">{errors.admin_id?.message}</small>
                    <small className="text-muted">
                      Este UID se obtiene desde la consola de Authentication
                    </small>
                  </div>
                </div>
              </div>

              <div className="form-group col-12 mt-4">
                <button className="btn btn-primary px-5 rounded" type="submit">
                  Registrar Admin
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>

      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  );
}
